export default "__VITE_ASSET__3a4f38ba__"